module.exports = __webpack_public_path__ + "fonts/HSESans-Thin.44c31c7.otf";